import { render, staticRenderFns } from "./PurchaseCourse.vue?vue&type=template&id=dd9db1c6&scoped=true"
import script from "./PurchaseCourse.vue?vue&type=script&lang=js"
export * from "./PurchaseCourse.vue?vue&type=script&lang=js"
import style0 from "./PurchaseCourse.vue?vue&type=style&index=0&id=dd9db1c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9db1c6",
  null
  
)

export default component.exports